/**
 * Monster Cart + Quick-Add compatibility fixes.
 *
 * Fix 1: Prevent Monster Cart from firing when the quick-add "Choose" button
 *         is clicked on a product card. The modal should open first so the user
 *         can pick a variant.
 *
 * Fix 2: Prevent double add-to-cart inside the quick-add modal. The theme sends
 *         a fetch and Monster Cart sends an XHR — both to /cart/add. We block
 *         the theme's fetch and let Monster Cart handle it.
 */
(function () {
  function init() {
    if (!document.querySelector('script[src*="/cart_renderer"]')) return;

    // --- Fix 1 ---------------------------------------------------------
    // Patch Choose buttons: set type="button" so they don't submit the form
    function patchChooseButtons() {
      var buttons = document.querySelectorAll('.quick-add__button--choose[type="submit"]');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute('type', 'button');
      }
    }
    patchChooseButtons();
    new MutationObserver(patchChooseButtons).observe(document.body, { childList: true, subtree: true });

    // Block Choose-button clicks from reaching Monster Cart (capture phase)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.quick-add__button--choose') : null;
      if (!btn) return;

      var quickAdd = btn.closest('quick-add-component');
      if (!quickAdd) return;
      if (btn.closest('.quick-add-modal') || btn.closest('quick-add-dialog')) return;
      if (quickAdd.getAttribute('data-quick-add-button') !== 'choose') return;

      e.stopPropagation();
      e.preventDefault();

      if (quickAdd.handleClick) {
        quickAdd.handleClick(e);
      }
    }, true);

    // Safety net: block form submissions from Choose-type quick-add on product cards
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      var quickAdd = form.closest('quick-add-component');
      if (!quickAdd) return;
      if (form.closest('.quick-add-modal') || form.closest('quick-add-dialog')) return;

      if (quickAdd.getAttribute('data-quick-add-button') === 'choose') {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    // --- Fix 2 ---------------------------------------------------------
    // When the quick-add dialog is open, block the theme's fetch to /cart/add
    // and let Monster Cart handle it via XHR.
    var _originalFetch = window.fetch;
    window.fetch = function (url, options) {
      var urlStr = typeof url === 'string' ? url : String(url);

      if (urlStr.includes('/cart/add') && document.querySelector('#quick-add-dialog dialog[open]')) {
        return Promise.resolve(new Response(JSON.stringify({ sections: {} }), {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        }));
      }

      return _originalFetch.apply(this, arguments);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
